export default __webpack_public_path__ + "static/media/detail_small_1_5.07727a06.png";